module.exports = __webpack_public_path__ + "static/media/glitter_brown.99885fc4.png";